import React from "react";
import { useParams } from "react-router-dom";
import { getPageType, getAppConfig } from "../components/Constants";

import AppDashboard from "../pages/AppDashboard";
import LogsPage from "./Logs/LogsPage";

const PageRouter = ({ setNavbarButtons }) => {
  const { group, type, logId } = useParams(); // Add logId here

  // Get the page type from constants
  const pageType = getPageType(group, type);
  const appConfig = getAppConfig(group, type);

  // If app is disabled, redirect or show message
  if (appConfig?.disabled) {
    return (
      <div className="p-8 text-center">
        <div className="bg-yellow-100 dark:bg-yellow-900/20 border border-yellow-500 rounded-lg p-6 max-w-md mx-auto">
          <span className="material-symbols-outlined text-6xl text-yellow-600 dark:text-yellow-400">
            construction
          </span>
          <h2 className="text-2xl font-bold mt-4 text-color">Coming Soon</h2>
          <p className="mt-2 text-alt-color">
            {appConfig.name} is currently under development.
          </p>
        </div>
      </div>
    );
  }

  // Route to appropriate page based on pageType
  switch (pageType) {
    case "logs":
      // LogsPage will handle both list and form views based on logId
      return (
        <LogsPage
          key={`${type}-${logId || "list"}`}
          setNavbarButtons={setNavbarButtons}
        />
      );

    case "invoice":
      return <AppDashboard />;

    case "document":
      // Future: Return DocumentPage component
      return (
        <div className="p-8 text-center">
          <div className="bg-blue-100 dark:bg-blue-900/20 border border-blue-500 rounded-lg p-6 max-w-md mx-auto">
            <span className="material-symbols-outlined text-6xl text-blue-600 dark:text-blue-400">
              description
            </span>
            <h2 className="text-2xl font-bold mt-4 text-color">
              Document Type
            </h2>
            <p className="mt-2 text-alt-color">
              This feature will use a document-based interface.
            </p>
          </div>
        </div>
      );

    default:
      // Fallback to invoice page
      return <AppDashboard />;
  }
};

export default PageRouter;
